import { useTranslation } from 'react-i18next'
import EmptyState from '../components/ui/EmptyState'

export default function NotFoundPage() {
  const { t } = useTranslation()
  return (
    <div className="page">
      <EmptyState
        icon="pi pi-compass"
        title={t('shell.notFound.title')}
        description={t('shell.notFound.desc')}
      />
    </div>
  )
}
